export default __webpack_public_path__ + "static/media/klupe.98bb93c6.jpg";